/**
 * @module components\ghDatePicker
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Model, Watch, Prop } from "vue-property-decorator";
import { Validator } from "vee-validate";

@Component
export default class GhDatePicker extends Vue {
  @Model("change")
  private value!: string;
  @Prop({ default: "选择日期" })
  private label!: string;

  @Prop({ default: "date" })
  private type!: "date" | "month" | "year";

  @Prop()
  private rules!: string;

  @Prop()
  private text!: string;

  @Prop()
  private validator!: Validator;

  private open = false;
  private date = "";

  private error = "";

  private temp = "";

  private get Value() {
    // let d = new Date();
    if (this.value) {
      let d = new Date(this.value);
      return d.toISOString().substr(0, 10);
    }
    return this.temp;
    // d.setHours(d.getHours() + 8);
  }

  private set Value(value) {
    if (this.validator && this.rules) {
      this.validator
        .verify(value, this.rules, { name: this.text })
        .then(res => {
          if (res.valid) {
            this.error = res.errors[0];
          } else {
            this.error = "";
          }
        });
    }
    this.temp = value;
    this.$emit("change", value);
  }

  // @Watch("value")
  // private resetValue() {
  //   let d = new Date();
  //   if (this.value) {
  //     d = new Date(this.value);
  //   }
  //   d.setHours(d.getHours() + 8);
  //   this.date = d.toISOString().substr(0, 10);
  // }

  // @Watch("date")
  // private reverse() {
  //   this.$emit("change", this.date);
  // }
}
